import { render } from "./VueTable.vue?vue&type=template&id=221d7218&ts=true"
import script from "./VueTable.vue?vue&type=script&lang=ts"
export * from "./VueTable.vue?vue&type=script&lang=ts"

import "./VueTable.vue?vue&type=style&index=0&id=221d7218&lang=scss"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VueTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "221d7218"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('221d7218', __exports__)) {
    api.reload('221d7218', __exports__)
  }
  
  module.hot.accept("./VueTable.vue?vue&type=template&id=221d7218&ts=true", () => {
    api.rerender('221d7218', render)
  })

}


export default __exports__